import { render, staticRenderFns } from "./RevisionDoneCreate.vue?vue&type=template&id=a81976c0&scoped=true"
import script from "./RevisionDoneCreate.vue?vue&type=script&lang=js"
export * from "./RevisionDoneCreate.vue?vue&type=script&lang=js"
import style0 from "./RevisionDoneCreate.vue?vue&type=style&index=0&id=a81976c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a81976c0",
  null
  
)

export default component.exports